/*************************************
* File generated by Slyck IDE
* Startups Component
*************************************/

import { useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback, Fragment } from 'react';

// state management
import { useDispatch, useSelector } from 'react-redux';
import { getScrollTop, setScrollTop as _setScrollTop, setScrollDirection as _setScrollDirection } from '../mainSlice';
//assets
import firebase_template from '../assets/firebase_template.png';
import slyck_project_screen from '../assets/slyck_project_screen.png';
import slyck_logo_bw from '../assets/slyck_logo_bw.svg';
import components_thumb from '../assets/components_thumb.png';
import pages_thumb from '../assets/pages_thumb.png';
import elements_thumb from '../assets/elements_thumb.png';
import download_app_store from '../assets/download_app_store.svg';
import app from '../assets/app.png';

// components
import Header from "../components/Header";
import Footer from "../components/Footer";
import { IoPlayCircle } from "react-icons/io5";
import Template from "../components/Template";

import styled from 'styled-components';


/*************************************
* Styled components
*************************************/

const STYLED_Q7SDH8 = styled.div`
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
`;
const STYLED_OKA8CT = styled.div`
  padding: 1.6rem;
`;
const STYLED_KXVTKJ = styled.div`
  max-width: 84rem;
  margin: 0 auto 4rem;
  text-align: center;
@media (max-width: 768px) {
    
      text-align: left;
    }
`;
const STYLED_PWS742 = styled.div`
  display: flex;
  max-width: var(--max-width);
  margin: 0 auto;
  column-gap: 4rem;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 2rem;
`;
const STYLED_HFQXWW = styled.div`
  font-size: var(--sub-heading-size);
  font-weight: 500;
`;
const STYLED_AADUMN = styled.div`
  font-size: var(--sub-heading-size);
`;
const STYLED_PLPIHJ = styled.a`
  background-color: var(--primary-color);
  padding: 1.2rem 1.6rem;
  color: white;
  border-radius: 0.8rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  column-gap: 1.2rem;
  margin-top: 2rem;
`;


/*************************************
* Component export
*************************************/

export default function Startups(props) {

  // actions
  const dispatch = useDispatch();
  const setScrollTop = useCallback((payload) => dispatch({type: 'setScrollTop', payload}), [dispatch]);
  const setScrollDirection = useCallback((payload) => dispatch({type: 'setScrollDirection', payload}), [dispatch]);
  const scrollTop = useSelector((state) => getScrollTop(state));
  
  useEffect(() => {
    document.title = '';
  }, []);
  
  /**
   * Handles the onScroll event for the undefined element.
   * @param {Object} event - event object passed from browser
   */
  const onScrollQ7sDH8 = (event) => {
    
    setScrollTop(event.target.scrollTop);
    if (event.target.scrollTop > scrollTop) {
      setScrollDirection('down');
    } else {
      setScrollDirection('up');
    }
  }

  return (
    <STYLED_Q7SDH8 onScroll={onScrollQ7sDH8} className={scrollTop <= 0 || !scrollTop ? 'scrolltop' : ''} data-slyck_id="Q7sDH8UoKbyvf3U6fvxc">
      <Header data-slyck_id="MvIezV6EXCLi4oyY9rpL" />
      <STYLED_OKA8CT data-slyck_id="oKa8CtCjDLl8lU8L1txu">
        <STYLED_KXVTKJ data-slyck_id="KXvtkjIofHo3qmw2v4Ou">
          <STYLED_HFQXWW data-slyck_id="HFQxWWYyhpzdUo0tmyOO">Slyck for Startups</STYLED_HFQXWW>
          <h1 data-slyck_id="2lPFrvUWPRZZKUJjvzpz">Create a SaaS app in minutes with Slyck.</h1>
          <STYLED_AADUMN data-slyck_id="aaduMNSrFOrs5SReQrqV">Slyck‘s free SaaS template provides the perfect foundation for you to speed up development and focus on what makes your product unique.</STYLED_AADUMN>
          <STYLED_PLPIHJ href={"https://youtu.be/NzaxKD5tvE4"} data-slyck_id="PlpihJksjZ9Qderrzh25"><IoPlayCircle /> Watch the video</STYLED_PLPIHJ>
        </STYLED_KXVTKJ>
        <STYLED_PWS742 data-slyck_id="Pws742BTGemozGyyk9s4">
          <Template data-slyck_id="IdIZponBvCqRiwZHjR1r" />
          <Template data-slyck_id="hPg27vWwP31zLUcBpLYT" />
        </STYLED_PWS742>
      </STYLED_OKA8CT>
      <Footer data-slyck_id="ljSvrJEI73aVgRbttJig" />
    </STYLED_Q7SDH8>
  );

}
